import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import FormattedName from 'I18n/components/FormattedName';
import { AvatarViewer } from '../features/avatar';
import { H1 } from 'foundations-components/transitional/components/H1';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UserProfile = ({
  avatarHash,
  firstName,
  lastName,
  email,
  use = 'responsive'
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const isStacked = isMobile || use === 'stacked';
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    alignSelf: "stretch",
    direction: isStacked ? 'column' : 'row',
    justify: "start",
    children: [/*#__PURE__*/_jsx(Box, {
      paddingBlockStart: "200",
      children: /*#__PURE__*/_jsx(AvatarViewer, {
        avatarHash: avatarHash,
        borderColor: "border-core-on-fill-default",
        borderStyle: "solid",
        borderWidth: "200",
        email: email,
        size: "lg"
      })
    }), /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(View, {
        color: "text-core-on-fill-default",
        marginBlockStart: isStacked ? '300' : undefined,
        marginInlineStart: isStacked ? undefined : '500',
        textAlign: isStacked ? 'center' : 'left',
        children: /*#__PURE__*/_jsx(H1, {
          "data-test-id": "user-full-name",
          margin: "0",
          children: /*#__PURE__*/_jsx(FormattedName, {
            familyName: lastName,
            givenName: firstName
          })
        })
      })
    })]
  });
};
export default UserProfile;